<script>
import elementState from "../../elementstate.vue";
import CalendarEvent from "./CalendarEvent";

export default {
    name: "calendar-event-element-state",
    components: { elementState },
    props: {
        event: {
            type: CalendarEvent,
            required: true
        },
        settings: {},
    },
    computed: {
        showStateIndicator() {
            return this.event.state && this.event.getDisplayInformation(this.settings);
        }
    }
}
</script>

<template>
    <div class="calendar-event-icon">
        <element-state
            v-if="showStateIndicator"
            :state="event.state"
            show-tooltip
            no-background-color
            class="state-indicator"
        />
    </div>
</template>

<style lang="scss">
.calendar-event-icon {
    display: flex;

    .element-state-icon {
        transition: color 0.3s ease-out;
        color: black !important;
    }

    .state-indicator {
        grid-column: 1;
        grid-row: 1;
    }
}
</style>
